<div class="div-action-top">
  <div class="left">
    <div class="form-filter ant-form">
      <div style="display: flex;float: left">
        <nz-select (ngModelChange)="getListData()" style="width: 180px;" nzShowSearch nzAllowClear
                   nzPlaceHolder="Chọn máy xét nghiệm"
                   [(ngModel)]="filter.recipient">
          <nz-option *ngFor="let m of machines" [nzLabel]="m.name" [nzValue]="m.name"></nz-option>
        </nz-select>
        &nbsp;
        <nz-select (ngModelChange)="getListData()" style="width: 180px;" nzShowSearch nzAllowClear
                   nzPlaceHolder="Chọn hóa chất"
                   [(ngModel)]="filter.chemicalName">
          <nz-option *ngFor="let m of chemicals" [nzLabel]="m.name" [nzValue]="m.name"></nz-option>
        </nz-select>
      </div>
      <div style="display: flex;float: right">
        <!--<button nz-button nzType="primary" class="btn-add-asset" type="button" *ngIf="checkAdd">
          <em class="fas fa-barcode fa-fw"></em> Quét barcode
        </button>-->

        <div style="padding: 4px">
          <strong>Scan barcode</strong>
          <nz-switch (ngModelChange)="toggleScanBarcode($event)" [(ngModel)]="activeScan"></nz-switch>
        </div>
        <div (blur)="leaveScanBarcode()">
          <nz-select (ngModelChange)="changeMachine($event)" style="width: 160px;margin-right: 10px;" nzShowSearch nzAllowClear nzPlaceHolder="Chọn máy xét nghiệm"
                     [(ngModel)]="selectedData.recipient">
            <nz-option *ngFor="let m of machines" [nzLabel]="m.name" [nzValue]="m.name"></nz-option>
          </nz-select>
          <input [disabled]="!activeScan" id="txtBarcode"
                 (ngModelChange)="handleBarcode($event)" style="width: 200px;" nz-input
                 placeholder="Scan barcode here" type="text" [(ngModel)]="selectedData.parcelDetailCode"/>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Hiển thị thông tin phiếu -->
<div class="data-table">
  <nz-table #basicTable [nzData]="filterData" (nzCurrentPageDataChange)="currentPageDataChange($event)"
            [nzPageSizeOptions]="pageSize" [nzPageSize]="defaultPage" nzSize="small" nzShowSizeChanger
            [nzShowTotal]="rangeTemplate" [nzLoading]="loading"
            [nzScroll]="{x: '800px'}"
  >
    <thead>
    <tr>
      <th nzShowCheckbox nzLeft="0px" nzWidth="50px" [(nzChecked)]="isAllDisplayDataChecked"
          [nzIndeterminate]="isIndeterminate" (nzCheckedChange)="checkAllRow($event)"></th>
      <th nzLeft class="text-nowrap" width="50px">#</th>
      <th nzLeft class="text-nowrap" width="150px">Mã phiếu</th>
      <th class="" width="180px">Mô tả phiếu</th>
      <th class="text-nowrap" width="180px">Máy xét nghiệm</th>
      <th class="text-nowrap" width="180px" nzFormat="dd/MM/yyyy HH:mm">Thời gian xuất</th>
      <th class="text-nowrap" width="180px">Người xuất</th>
      <!-- <th class="text-nowrap">Tiền thanh toán</th>
      <th class="text-nowrap">Mã HĐ thanh toán</th> -->
      <th nzRight class="z-index-2" width="60px">Action</th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let data of basicTable.data;let i = index;">
      <td nzShowCheckbox [(nzChecked)]="mapOfCheckedId[data.id]" (nzCheckedChange)="refreshStatus()" nzLeft="0px"
          nzWidth="50px"></td>
      <td nzLeft class="text-nowrap">{{getRowIndex(i, basicTable.nzPageIndex, basicTable.nzPageSize)}}</td>
      <td nzLeft class="text-nowrap">{{data.code}}</td>
      <td class="">{{data.description}}</td>
      <td class="text-nowrap">{{ data.recipient }}</td>
      <td class="text-nowrap">{{ data.exportDate | date:'dd/MM/yyyy HH:mm' }}</td>
      <td class="text-nowrap">{{ data.user.fullname }}</td>
      <td nzRight class="text-nowrap" width="60px">
        <!--<button nz-button nzSize="small" nzType="danger" class="btn-right" (click)="showConfirm(data.id)"
                *ngIf="checkDelete"><span class="fa fa-times fa-fw"></span>
        </button>-->
        <!--<button nz-button nzSize="small" nzType="default" class="btn-right" (click)="showModalUpdate(data)"
                *ngIf="checkUpdate"><span class="fa fa-edit fa-fw"></span>
        </button>-->
        <button nz-button nzSize="small" width="60px" nzType="primary" class="btn-right" (click)="showDetails(data)"
                *ngIf="checkDetails"><span class="fa fa-info fa-fw"></span>
        </button>
      </td>
    </tr>
    </tbody>
  </nz-table>
  <ng-template #rangeTemplate let-range="range" let-total>
    {{ range[0] }}-{{ range[1] }} {{'of' | translate }} {{ total }} {{'items' | translate }}
  </ng-template>
</div>

<!-- Thêm, sửa phiếu xuất -->
<nz-modal nzWidth="1200px" [(nzVisible)]="isVisibleAdd" nzClosable="false" [nzTitle]="title1" nzMaskClosable="false">
  <ng-template #title1>
    Xuất hóa chất cho máy xét nghiệm
    <div class="pull-right icon-close">
      <em (click)="handleCancel()" nz-icon nzType="close" nzTheme="outline"></em>
    </div>
  </ng-template>
  <div *ngIf="enableEdit">
    <div class="input-wrap nz-row row-width">
      <label class="title-detail text-text" nz-col [nzSpan]="4">Chọn máy xét nghiệm<em
        class="fa fa-asterisk required"></em></label>
      <div nz-col [nzSpan]="12">
        <!--<input nz-input placeholder="Nhà cung cấp" formControlName="receiveType"/>-->
        <nz-select [disabled]="viewOnly" nzShowSearch nzAllowClear nzPlaceHolder="Chọn máy xét nghiệm"
                   [(ngModel)]="selectedData.recipient" style="width: 100%">
          <nz-option *ngFor="let m of machines" [nzLabel]="m.name" [nzValue]="m.name"></nz-option>
        </nz-select>
      </div>
    </div>
    <div class="input-wrap nz-row row-width" *ngIf="!viewOnly">
      <label class="title-detail text-text" nz-col [nzSpan]="4">&nbsp;</label>
      <div nz-col [nzSpan]="16">
        <input [disabled]="viewOnly" (ngModelChange)="handleBarcode($event)" style="width: 300px;"
               *ngIf="selectedData.scanBarcode" nz-input placeholder="Paste barcode here" type="text"
               [(ngModel)]="selectedData.parcelDetailCode"/>
      </div>
    </div>
  </div>
  <button *ngIf="viewOnly" nz-button nzSize="small" nzType="primary" class="btn-add-asset btn-right" type="button"
          (click)="exportPDF()">
    <em class="fas fa-file-pdf fa-fw"></em>
    In phiếu
  </button>
  <!-- Thông tin chi tiết phiếu xuất -->
  <nz-table [nzData]="datas" [nzShowPagination]="false" #spreadsheet width="100%" [nzScroll]="{ y: '250px' }"
            id="detailTable">
    <thead>
    <tr>
      <th nzWidth="70px">STT</th>
      <th nzWidth="140px">Hóa chất</th>
      <th nzWidth="120px">Barcode</th>
      <th nzWidth="100px">Số LOT</th>
      <th nzWidth="150px">Số lượng</th>
      <th nzWidth="180px">Mã lô hóa chất</th>
      <th nzWidth="80px"></th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let item of selectedData.warehouseExportDetails; let i = index">
      <td>
        {{ i + 1 }}
      </td>
      <td>
        {{item.chemical.name}}
      </td>
      <td>
        {{item.parcelDetailCode}}
      </td>
      <td>
        {{item.lotNumber}}
      </td>
      <td>
        1
      </td>
      <td>
        {{item.batchCode}}
      </td>
      <td>
        <button *ngIf="!viewOnly" nzSize="small" nz-button nzType="danger" class="button-update btn-right"
                (click)="deleteDetail(item)">Xóa
        </button>
      </td>
    </tr>
    </tbody>
  </nz-table>
  <div *nzModalFooter>
    <button nz-button (click)="handleCancel()">{{'cancel' | translate }}</button>
    <button [nzLoading]="loadingButton" nz-button *ngIf="!viewOnly" nzType="primary" (click)="handleOk()"
            class="button-submit">{{'save' | translate }}</button>
  </div>
</nz-modal>
